exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  width: 900px;\n  height: 500px;\n  position: relative; }\n\n#slider {\n  margin: 20px; }\n\n.kWgQNm {\n  box-sizing: border-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  max-width: unset;\n  min-width: unset;\n  min-height: unset;\n  cursor: unset;\n  transform: unset;\n  word-break: unset;\n  z-index: unset;\n  padding: 0px;\n  margin: 0px;\n  overflow: unset;\n  background: unset;\n  border-right: unset;\n  border-bottom: unset;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  border-radius: unset;\n  transition: initial; }\n\n.kWgQNm .active, .kWgQNm .sc-bdVaJa:hover {\n  background-color: #1eacb2;\n  color: white;\n  border-bottom: 1px solid #1eacb2; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/play-trip/play-trip.component.scss
// module id = ../../../../../src/app/play-trip/play-trip.component.scss
// module chunks = main